// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"style-module_toggleContainer__OboFUnixrFusynL2Ex_Y"};